import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=40ea48e0&"
import script from "./CardCarousel.vue?vue&type=script&lang=js&"
export * from "./CardCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports